import { render, staticRenderFns } from "./CoproductionTerms.vue?vue&type=template&id=e992ccc6&scoped=true&"
var script = {}
import style0 from "./CoproductionTerms.vue?vue&type=style&index=0&id=e992ccc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e992ccc6",
  null
  
)

export default component.exports